import { useIdCard } from '../../screens/HomeScreen/context/idCard';
import { PhysicalWrapper, WeightIcon, DimenssionsIcon, DimenssionsText } from './styles';

const Physical = ({ totalWeightDry, length, height, width }) => {
  return (
    <PhysicalWrapper>
      <WeightIcon />
      <DimenssionsText>{`${totalWeightDry}t`}</DimenssionsText>
      <DimenssionsIcon />
      <DimenssionsText>{`${length}m (l) x ${width}m (w) x ${height}m (h)`}</DimenssionsText>
    </PhysicalWrapper>
  );
};

export default Physical;
